import {
    CUSTOMERFOCUS_DISPLAY_FILTER,
    CUSTOMERFOCUS_YEAR_FILTER,
    CUSTOMERFOCUS_QTR_FILTER,
    CUSTOMERFOCUS_MONTH_FILTER,
    CUSTOMERFOCUS_PRODUCTORDER_DISPLAY_FILTER,
    CUSTOMERFOCUS_PRODUCTORDER_ITEMGROUP_FILTER,
    CUSTOMERFOCUS_PRODUCTORDER_PRODUCTGROUP_FILTER,
    CUSTOMERFOCUS_PRODUCTORDER_PRODUCTLINE_FILTER,
    CUSTOMERFOCUS_SALESHISTORY_DISPLAY_FILTER,
    CUSTOMERFOCUS_SALESHISTORY_AMOUNT_FILTER,
    CUSTOMERFOCUS_SALESHISTORY_ITEMGROUP_FILTER,
    CUSTOMERFOCUS_SALESHISTORY_PRODUCTGROUP_FILTER,
    CUSTOMERFOCUS_SALESHISTORY_PRODUCTLINE_FILTER,
    CUSTOMERFOCUS_SALESHISTORY_PRODUCTTYPE_FILTER,
    CUSTOMERFOCUS_SEARCH_TRIGGER
} from '../constants/ActionTypes';

export const customerFocusSelectDisplay = selected => {
    return {
        type: CUSTOMERFOCUS_DISPLAY_FILTER,
        payload: selected
    }
}

export const customerFocusSelectYear = selected => {
    return {
        type: CUSTOMERFOCUS_YEAR_FILTER,
        payload: selected
    }
}

export const customerFocusSelectQtr = selected => {
    return {
        type: CUSTOMERFOCUS_QTR_FILTER,
        payload: selected
    }
}

export const customerFocusSelectMonth = selected => {
    return {
        type: CUSTOMERFOCUS_MONTH_FILTER,
        payload: selected
    }
}

export const customerFocusProductOrderSelectDisplay = selected => {
    return {
        type: CUSTOMERFOCUS_PRODUCTORDER_DISPLAY_FILTER,
        payload: selected
    }
}

export const customerFocusProductOrderSelectItemGroup = selected => {
    return {
        type: CUSTOMERFOCUS_PRODUCTORDER_ITEMGROUP_FILTER,
        payload: selected
    }
}

export const customerFocusProductOrderSelectProductGroup = selected => {
    return {
        type: CUSTOMERFOCUS_PRODUCTORDER_PRODUCTGROUP_FILTER,
        payload: selected
    }
}

export const customerFocusProductOrderSelectProductLine = selected => {
    return {
        type: CUSTOMERFOCUS_PRODUCTORDER_PRODUCTLINE_FILTER,
        payload: selected
    }
}

export const customerFocusSalesHistorySelectDisplay = selected => {
    return {
        type: CUSTOMERFOCUS_SALESHISTORY_DISPLAY_FILTER,
        payload: selected
    }
}

export const customerFocusSalesHistorySelectAmount = selected => {
    return {
        type: CUSTOMERFOCUS_SALESHISTORY_AMOUNT_FILTER,
        payload: selected
    }
}

export const customerFocusSalesHistorySelectItemGroup = selected => {
    return {
        type: CUSTOMERFOCUS_SALESHISTORY_ITEMGROUP_FILTER,
        payload: selected
    }
}

export const customerFocusSalesHistorySelectProductGroup = selected => {
    return {
        type: CUSTOMERFOCUS_SALESHISTORY_PRODUCTGROUP_FILTER,
        payload: selected
    }
}

export const customerFocusSalesHistorySelectProductLine = selected => {
    return {
        type: CUSTOMERFOCUS_SALESHISTORY_PRODUCTLINE_FILTER,
        payload: selected
    }
}

export const customerFocusSalesHistorySelectProductType = selected => {
    return {
        type: CUSTOMERFOCUS_SALESHISTORY_PRODUCTTYPE_FILTER,
        payload: selected
    }
}

export const customerFocusSetSearchTrigger = trigger => {
    return {
        type: CUSTOMERFOCUS_SEARCH_TRIGGER,
        payload: trigger
    }
}